import { render, staticRenderFns } from "./new-user-guide.vue?vue&type=template&id=c7f23ef2&scoped=true&"
import script from "./new-user-guide.vue?vue&type=script&lang=js&"
export * from "./new-user-guide.vue?vue&type=script&lang=js&"
import style0 from "./new-user-guide.vue?vue&type=style&index=0&id=c7f23ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f23ef2",
  null
  
)

export default component.exports